import { MapPin, Mail, Lock } from "lucide-react";
import { Link } from "react-router-dom";

export const Footer = () => {
  return (
    <footer id="contact" data-testid="footer" className="bg-[#050505] border-t border-white/10 pt-20 pb-10">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="grid md:grid-cols-2 gap-12 items-start">
          <div>
            <div className="flex items-center gap-3 mb-6">
              <img
                src="https://customer-assets.emergentagent.com/job_adult-baseball-hub/artifacts/b8ws7h83_wabl%20logo.jpg"
                alt="WABL logo"
                className="h-16 w-16 object-contain"
              />
              <span className="font-heading text-3xl tracking-tight">WABL</span>
            </div>
            <p className="font-heading text-3xl sm:text-4xl uppercase tracking-tighter leading-[0.95] max-w-md">
              The Game You Love. <span className="text-[#FF3B30]">The Schedule You Need.</span>
            </p>
            <a
              href="#signup"
              data-testid="footer-signup-cta"
              className="inline-block mt-8 font-heading uppercase tracking-wide bg-[#FF3B30] text-white hover:bg-[#FF6B63] transition-colors px-8 py-4"
            >
              Join The League
            </a>
          </div>

          <div className="md:text-right space-y-6">
            <div>
              <p className="text-xs font-bold uppercase tracking-[0.3em] text-[#8A94A0] mb-3">Location</p>
              <p className="flex md:justify-end items-center gap-2 text-lg font-bold">
                <MapPin size={20} className="text-[#FF3B30]" /> Virginia, USA
              </p>
            </div>
            <div>
              <p className="text-xs font-bold uppercase tracking-[0.3em] text-[#8A94A0] mb-3">Get In Touch</p>
              <a
                href="mailto:info@wabl.com"
                data-testid="footer-email"
                className="flex md:justify-end items-center gap-2 text-lg font-bold hover:text-[#FF3B30] transition-colors"
              >
                <Mail size={20} className="text-[#FF3B30]" /> info@wabl.com
              </a>
            </div>
          </div>
        </div>

        <div className="mt-16 pt-8 border-t border-white/10 flex flex-col sm:flex-row justify-between items-center gap-4">
          <p className="text-sm text-[#8A94A0] font-medium">
            © {new Date().getFullYear()} Weekend Adult Baseball League. No drama. Just baseball.
          </p>
          <Link
            to="/admin"
            data-testid="admin-link"
            className="flex items-center gap-2 text-xs font-bold uppercase tracking-[0.2em] text-[#5b626b] hover:text-white transition-colors"
          >
            <Lock size={14} /> Admin
          </Link>
        </div>
      </div>
    </footer>
  );
};
